import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="verlag" className="relative h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="/images/hero-library.jpg" 
          alt="Alte Bücher in einer Bibliothek" 
          className="w-full h-full object-cover" 
        />
        <div className="absolute inset-0 bg-brand/60 dark:bg-navy-950/75 mix-blend-multiply dark:mix-blend-normal transition-colors duration-300"></div>
      </div>
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6"
        >
          Gedanken, welche die Zeit überdauern
        </motion.h1>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-lg md:text-2xl text-stone-200 mb-10 font-light"
        >
          Willkommen bei Vidento. Entdecken Sie vergessene Schätze, methodisch saubere Analysen und Geschichten für die nächste Generation.
        </motion.p>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <button 
            onClick={() => document.getElementById('abteilungen')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-amber-700 hover:bg-amber-800 text-white px-8 py-3 rounded-sm text-lg transition-all duration-300 shadow-lg"
          >
            Unsere Bücher entdecken
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;